export default "__VITE_ASSET__DJMxk0ex__"